import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-games-root-v2',
  templateUrl: './games.template.html',
  styleUrls: ['./games.template.scss'],
})
export class GamesWrapperComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor() {}

  ngOnInit() {}

  ngOnDestroy() {}

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/games.component.ts